    <template>
        <div v-if="type === 'component'" class="squad-container component">
            <div class="squad-title">
                {{ $t('SQUAD_STATUS') }}
            </div>

            <div v-for="(i,i1) in getListLength" :key="i1" class="squad-box">
                <div class="squad-count home-count"
                    :class="{'less': i.home < i.away}">
                    {{ i.home }}
                </div>
                <div class="squad-type">
                    {{ i1 === 'BACKUP' ? $t('RESERVE') : $t(i1) }}
                    <div v-if="i.previousLineup" class="squad-hint">
                        {{ $t('PREVIOUS_LINEUP') }}
                    </div>
                </div>
                <div class="squad-count away-count"
                    :class="{'less': i.away < i.home}">
                    {{ i.away }}
                </div>
            </div>

            <div class="show-more" @click="seeAll()" v-if="type === 'component'">
                {{ showMore ? $t('SEE_LESS') : $t('SEE_ALL') }}
            </div>
        </div>
        <div v-else>
            <div class="squad-container page">

                <div class="squad-title is-web">
                    {{ $t('SQUAD_STATUS') }}
                </div>
                
                <!-- @command: team tab -->
                <div class="squad-team-list">
                    <div class="squad-team " v-for="(i, i1) in results"

                        @click="handleClickTeam(teamSide(i.teamId, i1) === 'home' ? 0 : 1)"
                        :class="{
                            'selected': (teamSide(i.teamId, i1) === 'home' ? 0 : 1) === teamSelectedIndex,
                            'nav-pill btn-aspn-default': !isMobile
                        }">
                            <Icon :logoUrl="teamSide(i.teamId, i1) === 'home' ? matchScoreData.homeLogo : matchScoreData.awayLogo"
                                class="mr-05rem home-match__title-flag">
                            </Icon>
                        <div class="squad-team-name">
                            {{ i.teamName }}
                        </div>
                    </div>
                </div>

                <!-- @command: list type tab -->
                <div class="is-mobile">
                    <div class="squad-tab-list">
                        <div class="squad-tab nav-pill btn-aspn-default" 
                            v-for="(i, i1) in tabs"
                            :key="i1"
                            @click="handleClickTab(i)"
                            :class="{ selected: i.selected }">
                            {{ $t(i.name) }}
                        </div>
                    </div>
                </div>
            </div>

            <div  class="squad-content">
                <div class="squad-list">
                    <!-- @command: header > isMobile -->
                    <div class="is-mobile">
                        <div class="squad-header">
                            <div class="squad-num"
                                :class="{ 'away-color': teamSelectedIndex === 1 }"> 
                                {{ getList.length }}
                            </div>
                            <div class="squad-tab-key">
                                {{ $t(tabSelected) }}
                                <div v-if="tabSelected !== 'ABSENCE'" class="previous-lineup">
                                    {{ $t('PREVIOUS_LINEUP') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- @command: list > isMobile -->
                    <template v-if="isMobile">
                        <template v-if="getList.length === 0">
                             <NoData />
                        </template>
                        <div class="squad-player-list" v-else>
                            <div class="squad-player-item" v-for="(i, i1) in getList">
                                <div class="squad-player-item-num">
                                {{ i.number }}
                                </div>
                                <Navigation :id="i.playerId" :category="'player'" :name="i.name">
                                    <Icon  :category="'player'" :logoUrl="i.playerUrl"  class="player-head"></Icon>
                                </Navigation>
                                <div class="player-item-data">
                                    <div class="player-item-name">
                                        {{ i.name }}
                                    </div>
                                    <div class="player-item-position">
                                        {{ i.pos }}
                                    </div>
                                    <div v-if="tabSelected === 'ABSENCE'"
                                        class="player-item-reason">
                                        {{ i.reason }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- @command: list > isWeb -->
                    <div v-else class="squad-web-list">
                        <div class="squad-web-box"  v-for="(a,i0) in getFullList">
                            
                            <!-- @command: header > isWeb -->
                            <div class="squad-header">
                                <div class="squad-num"
                                    :class="{ 'away-color': teamSelectedIndex === 1 }"> 
                                    {{ a.length }}
                                </div>
                                <div class="squad-tab-key">
                                    {{ i0 === 'BACKUP' ? $t('RESERVE') : $t(i0) }}
                                    <div v-if="i0 !== 'ABSENCE'" class="previous-lineup">
                                        {{ $t('PREVIOUS_LINEUP') }}
                                    </div>
                                </div>
                            </div>

                            <template v-if="a.length === 0">
                                <div class="squad-player-item">
                                    <NoData class="w-100" />
                                </div>
                            </template>
                            <div class="squad-player-list" v-else>
                                <div class="squad-player-item" v-for="(i, i1) in a">
                                    <div class="squad-player-item-num">
                                    {{ i.number }}
                                    </div>
                                    <Navigation :id="i.playerId" :category="'player'" :name="i.name">
                                        <Icon  :category="'player'" :logoUrl="i.playerUrl"  class="player-head"></Icon>
                                    </Navigation>
                                    <!-- <div class="player-head"></div> -->
                                    <div class="player-item-data">
                                        <div class="player-item-name">
                                            {{ i.name }}
                                        </div>
                                        <div class="player-item-position">
                                            {{ i.pos }}
                                        </div>
                                        <div v-if="i0 === 'ABSENCE'"
                                            class="player-item-reason">
                                            {{ i.reason }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </template>


    <script>
    import { mapActions, mapGetters } from "vuex";
    export default {
        name: 'LeagueSquad',
        data() {
        return {
            headerLabel: ["NUMBER", "PLAYER", "POSITION", "REASONS_ABSENCE"],
            subHeaderLabel: ["NUMBER", "PLAYER", "POSITION"],
            tabSelected: 'ABSENCE',
            tabs: [
                { name: "ABSENCE", selected: true },
                { name: "STARTER", selected: false },
                { name: "RESERVE", selected: false },
            ],
            teamSelectedIndex: 0,
            teamSelected: "home",
            lineupSelected: "starter",
            
            lineup: null,
            matchId: "",
            results: null,
            mobileResults: null,
            // isLoading: false,
            isNodata: false,
            isSkeletonLoading: {
            squadStatus: false,
            },
            matchDetailScore2: {}
        };
    },
    props: {
        matchDetailScore: Object,
        type: String
    },
    created() {
        this.matchId = this.$route.params.matchId;
    },
    mounted() {
        this.getSquadStatusData();
        if(!this.matchDetailScore || (typeof this.matchDetailScore === 'object' && Object.keys(this.matchDetailScore).length === 0)) {
            this.getMatchDetailScoreDataAsync()
        } 
        this.handleClickTeam(0)
    },
    watch: {
        matchDetailScore(newVal) {
        },
        teamSelected(newVal) {
            this.mobileResults = this.results[newVal];
            this.lineup = this.mobileResults.previousLineup[this.lineupSelected];
        },
        lineupSelected(newVal) {
            this.lineup = this.mobileResults.previousLineup[newVal];
        },
        currentLocale: {
            deep: true,
            handler(newVal, oldVal) {
                this.getSquadStatusData();
            },
        },
        manualRefreshMatchDetail: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.getSquadStatusData();
                }
            },
        },
    },
    computed: {
        ...mapGetters([
            "isMobile", 
            "currentLocale",
            "currentSportType",
            "manualRefreshMatchDetail",
        ]),
        getList() {
            let data = [] 
            if(this.results) {
                data = this.teamSelectedIndex === 0 ? this.results.homeTeamSquad : this.results.awayTeamSquad
                if(data) {
                    if(this.tabSelected === 'ABSENCE') {
                        return data.injurySuspension
                    } else if(this.tabSelected === 'STARTER') {
                        return data.previousLineup.starter
                    } else if(['BACKUP','RESERVE'].includes(this.tabSelected)) {
                        return data.previousLineup.backup
                    }
                }
            }
            return []
        },
        getFullList() {
            let data = [] 
            if(this.results) {
                data = this.teamSelectedIndex === 0 ? this.results.homeTeamSquad : this.results.awayTeamSquad
                if(data) {
                    return {
                        ABSENCE: data.injurySuspension,
                        STARTER: data.previousLineup.starter,
                        BACKUP: data.previousLineup.backup
                    }
                }
                return {}
            }
            return {
                ABSENCE: [],
                STARTER: [],
                BACKUP: []
            }
        },
        getListLength() {
            if(this.results) {

                let home =  this.results.homeTeamSquad
                let away = this.results.awayTeamSquad
                let data = {
                    ABSENCE: {
                        home: home.injurySuspension.length,
                        away: away.injurySuspension.length
                    },
                    STARTER: {
                        home: home.previousLineup.starter.length,
                        away: away.previousLineup.starter.length,
                        previousLineup: true
                    },
                    BACKUP: {
                        home: home.previousLineup.backup.length,
                        away: away.previousLineup.backup.length,
                        previousLineup: true
                    }
                }
                return data
            }
            return {}
        },
        matchScoreData() {
            if(this.matchDetailScore || (typeof this.matchDetailScore === 'object' && Object.keys(this.matchDetailScore).length !== 0)) {
                return this.matchDetailScore
            } else {
                return this.matchDetailScore2
            }
        }
    },
    methods: {
        ...mapActions([
            "getSquadStatus",
            'getMatchDetailScoreWinRate',
            'getMatchDetailScoreAsync',
            'getMatchDetailScoreLatestEuropeOdds',
        ]),
        shiftArr(arr) {
            delete arr.matchId;
            return arr;
        },
        selectTeam(id) {
            this.teamSelected = id;
        },
        selectLineup(id) {
            this.lineupSelected = id;
        },
        async getSquadStatusData() {
            // this.isLoading = true;
            if (this.manualRefreshMatchDetail) {
            this.isSkeletonLoading.squadStatus = true;
            }
            const result = await this.getSquadStatus({ matchId: this.matchId });
            if (this.manualRefreshMatchDetail) {
            this.isSkeletonLoading.squadStatus = false;
            this.verifyIfAllAPICallsDone();
            }
            // this.isLoading = false;

            this.dataValidation(result.result);
        },
        dataValidation(data) {
            if (!data.matchId) {
            this.isNoData = true;
            } else {
            this.isNodata = false;
            this.results = this.shiftArr(data);
            // this.mobileResults = this.results[this.teamSelected];
            // this.lineup = this.mobileResults.previousLineup[this.lineupSelected];
            }
        },
        verifyIfAllAPICallsDone() {
            if (!this.isSkeletonLoading.squadStatus) {
            this.$emit("apiCallsDone");
            }
        },
        teamSide(teamId, index) {
            if(teamId === this.matchScoreData?.homeTeamId) {
                return 'home'
            } else {
                if(index === 'homeTeamSquad') {
                    return 'home'
                }
                return 'away'
            }
        },
        handleClickTab(i) {
            this.tabs.forEach(a => {
                a.selected = false;
            })
            i.selected = true
            this.tabSelected = i.name
        },
        handleClickTeam(i) {

            this.teamSelectedIndex = i
        },
        seeAll() {
            let params = this.$route.params
            if(this.type === 'component') {
                this.$router.push(`/${this.currentLocale}/${this.currentSportType}/${params.country}/${params.club}/${params.opponent}/${params.matchId}/analysis-details/squad-status`)
            } else {
            }
        },
        async getMatchDetailScoreDataAsync() {
            let params = {
                matchId: this.$route.params.matchId,
                timeZone: this.$tools.getCurrentTimeZone(),
            };

            const resultWinRate = await this.getMatchDetailScoreWinRate(params);
            const result = await this.getMatchDetailScoreAsync(params);
            const resultOdd = await this.getMatchDetailScoreLatestEuropeOdds(params);

            this.matchDetailScore2 = result.result
            // this.matchDetailWinRate =
            //     resultWinRate.result == null ? {} : resultWinRate.result;

            // this.matchDetailOdds = resultOdd.result;
            // if (resultOdd.result === null) {
            //     this.matchDetailOdds = {};
            //     this.matchDetailOdds.awayOdds = "-";
            //     this.matchDetailOdds.drawOdds = "-";
            //     this.matchDetailOdds.homeOdds = "-";
            // }

            // this.matchDetailScore.matchState = 1;
            // this.matchDetailScore.containLiveStream = true;
            // this.updateLiveStreamTrackerScoreFavUI(this.matchDetailScore);

            // this.isHasLive(this.matchDetailScore.containLiveStream);

            // this.intiHighlightDetailLink();
            // if (!this.manualRefreshMatchDetailScore) {
                // this.initLiveVideo();
            // }
        },
    },
};
</script>

<style scoped>
.squad-container {
    padding: 16px;
    box-sizing: border-box;
    background-color: var(--color-background-default-secondary);
    margin-bottom: 16px;
}
.squad-content {
    padding: 0 8px;
    box-sizing: border-box;
}
.squad-container.component {

    border-radius: 16px;
}
.squad-container.page {
    padding-top: 32px;
    margin-top: 16px;
    border-top: 1px dashed var(--color-border-default-default);
}
.squad-title {
    font-size: 24px;
    text-align: center;
    font-family: var(--weight-600);
    margin-bottom: 16px;
    color: var(--color-text-default-default);
}
.squad-box {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 8px 0;
    margin-bottom: 8px;
    box-sizing: border-box;
}
.squad-count {
    width: 64px;
    height: 40px;
    border-radius: 8px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-default-netural);
    font-family: var(--weight-600);
}
.home-count {
    background-color: var(--primary-400);
    margin-left: 12.5px;
}
.squad-type {
    width: 150px;
    font-size: 16px;
    font-family: var(--weight-600);
    text-align: center;
    letter-spacing: 0.64px;
    line-height: 140%;
    color: var(--color-text-default-default);
}
.squad-hint {
    font-size: 14px;
    font-family: var(--weight-400);
    line-height: 140%;
    color: var(--color-text-default-secondary);
}
.away-count {
    background-color: var(--secondary-400);
    margin-right: 12.5px;
}
.away-count.less,
.home-count.less {
    opacity: .4;
}
.show-more {
    width: 100%;
    text-align: center;
    padding: 8px;
    box-sizing: border-box;
    font-size: 16px;
    color: var(--color-text-default-default);
    letter-spacing: 0.64px;
}

.squad-team-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.squad-team {
    display: flex;
    align-items: center;
    font-family: var(--weight-600);
    font-size: 14px;
    gap: 8px;
    padding: 0px 8px 8px;
    /* margin: 0 8px; */
    white-space:nowrap; 
    overflow:hidden; 
    text-overflow:ellipsis;
    color: var(--color-text-default-default);
}
.squad-team.nav-pill {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 24px;
}
.squad-team.selected {
    position: relative;
    color: var(--color-text-default-default);
}
.squad-team.selected:after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: var(--primary-500);
    content: '';
    display: block;
}
.squad-tab-list {
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.squad-tab {
    flex: 1;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    border-radius: 17px;
}
.squad-container {
    padding: 16px;
}
.squad-list {
    padding: 16px;
    border-radius: 16px;
    background-color: var(--color-background-default-secondary);
}
.squad-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
}
.squad-num {
    font-size: 48px;
    font-family: var(--weight-700);
    color: var(--primary-400);
}
.squad-num.away-color {
    color: var(--secondary-400);
}
.squad-tab-key {
    font-size: 24px;
    font-family: var(--weight-600);
    color: var(--color-text-default-default);
}
.squad-player-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 0;
}
.squad-player-item-num {
    /* padding: 0 6px; */
    width: 20px;
    box-sizing: border-box;
    text-align: center;
    font-family: var(--weight-600);
    font-size: 13px;
    color: var(--color-text-default-default);
}
.player-head {
    width: 36.8px;
    height: 36.8px;
    padding: 1.6px;
    background-color: var(--color-background-default-default-hover);
    border-radius: 50%
}
.player-item-data {
}
.player-item-name {
    font-size: 16px;
    font-family: var(--weight-600);
    color: var(--color-text-default-default);
}
.player-item-position {

    font-size: 14px;
    font-family: var(--weight-400);
    color: var(--color-text-default-secondary);
}
.player-item-reason {
    padding-top: 3px;
    font-size: 13px;
    font-family: var(--weight-400);
    color: var(--color-text-default-secondary);
    text-transform: capitalize;
}
.previous-lineup {
    color: var(--color-text-default-secondary);
    font-size: 16px;
}
.squad-web-list {
    display: flex;
    gap: 16px;
}
.squad-web-box {
    flex: 1;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--color-border-default-default);
}

@media(max-width: 768px) {
.squad-container.page {
    padding-top: 16px;
    margin-top: 0;
    border-top: 0;
}
.squad-content {
    padding-bottom: 60px;
}
.squad-team-name {
    max-width: 140px;
    white-space: nowrap; /* 文本不换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */

}
}
</style>